import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop, Provide } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import _ from 'lodash';
import { ISchemaDataDTO } from 'dto/ISchemaDataDTO';
import { IFlowStartupReferenceDTO } from 'dto/IFlowStartupReferenceDTO';

// tslint:disable-next-line:variable-name
const FlowTemplateAction = namespace('flowTemplate').Action;
// tslint:disable-next-line:variable-name
const FlowTemplateGetter = namespace('flowTemplate').Getter;
@Component({
  name: 'PlumbNodeMixin',
})
export default class PlumbNodeMixin extends Vue {
  @FlowTemplateAction('schema') loadSchema;

  @FlowTemplateGetter schemes;

  @Prop({ required: true, type: Array })
  nodeTypes: ISchemaDataDTO[];

  @Prop({ required: true, type: Array })
  startupTypes: IFlowStartupReferenceDTO[];

  @Prop({ required: true, type: Array })
  value: any[];

  @Prop({ required: false, type: String })
  nodeId: string;

  @Prop({ required: false, type: Object })
  flow: any;

  @Provide('startupTypes') get startupTypesProvider() {
    return this.startupTypes;
  }

  selectedNode: any = null;

  get selectedNodeType() {
    if (!this.selectedNode) {
      return null;
    }
    if (!this.nodeTypes) {
      return null;
    }
    return this.nodeTypes.find((n) => n.name === this.selectedNode.typeName);
  }

  mounted() {
    this.handleNodeClick(this.nodeId);
  }

  @Watch('value')
  handleValueChange() {
    this.handleNodeClick(this.nodeId);
  }

  @Watch('nodeId')
  async handleNodeClick(nodeId) {
    this.selectedNode = null;
    const sn = this.value.find((n) => n.guid === nodeId);
    if (sn != null) {
      await this.loadSchema(sn.typeName);
      this.selectedNode = sn;
    }
  }

  get schema() {
    if (this.schemes && this.selectedNode) {
      return this.schemes[this.selectedNode.typeName];
    }
    return null;
  }

  get editor(): string {
    if (!this.selectedNode) {
      return null;
    }
    switch (this.selectedNode.typeName) {
      case 'Actions.ActivityAndWait':
      case 'Actions.ActivityAndContinue':
        return 'activity';
      case 'Actions.OpportunityAndWait':
      case 'Actions.OpportunityAndContinue':
        return 'opportunity';
      case 'Events.EMail':
        return 'email';
      case 'Events.ChangeOwner':
      case 'Events.ChangeSalesPerson':
        return 'account';
      case 'Events.Sms':
        return 'sms';
      case 'Events.ChangeZone':
        return 'zone';
      case 'Events.InfoBox':
        return 'info-box';
      case 'Events.EventExtension':
      case 'Conditions.IfExtension':
        return 'event-extension';
      case 'Conditions.If':
      case 'Conditions.IfBusinessObjectLoad':
        return 'if';
      case 'Events.ExtendOpportunityTimeout':
      case 'Events.ExtendActivityTimeout':
      case 'Actions.Wait':
        return 'extend-timeout';
      case 'Events.AddToList':
      case 'Events.RemoveFromList':
        return 'list';
      case 'Ends.EndFailure':
      case 'Ends.EndSuccess':
        return 'end';
      case 'Events.CreateBusinessObject':
      case 'Events.EditBusinessObjectProperty':
        return 'bo';
      case 'Events.CampaignEMail':
        return 'mailing';
      case 'Conditions.CampaignEMailOpen':
        return 'mailing-open';
      case 'Conditions.CampaignEMailClick':
        return 'mailing-click';
      case 'Events.Message':
        return 'message';
      case 'Events.StartFlow':
        return 'flow';
    }
    console.warn(`Missing editor for ${this.selectedNode.typeName} typeName`);
    return null;
  }
}
